import React from 'react';
import { Radio } from 'antd';
import { RadioGroupProps } from 'antd/lib/radio/interface';

export type { RadioGroupProps };

const ProRadioGroup: React.FC<RadioGroupProps> = React.forwardRef<
  any,
  RadioGroupProps
>((props, ref) => {
  const { children, ...resProps } = props;
  return (
    <Radio.Group ref={ref} {...resProps}>
      {children}
    </Radio.Group>
  );
});

export default ProRadioGroup;
